import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { DatePicker, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const Date = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()
  const type = useWatch({ control, name: `suspiciousActivityInfo.cyberEventIndicators.${index as 0}.type` })

  return (
    <Controller
      name={`suspiciousActivityInfo.cyberEventIndicators.${index as 0}.date`}
      control={control}
      render={({ field }) => (
        <FF2
          label="Date"
          field={field}
          input={(props) => (
            <DatePicker
              {...props}
              disabled={!(type && ['Command and control IP address', 'Suspicious IP address'].includes(type))}
            />
          )}
        />
      )}
    />
  )
}
